<template>

<div>
    <el-row>
        <el-col :span="24">
            <div class="grid-content bg-purple-light">

                <div class="searchTitle">
                    <b style="font-size: 20px !important;">  박스매핑  </b>
      </div>

      <!-- 조회 조건 영역 -->
      <div class="searchBody">
        <!-- 조회 조건 영역 -->

          <div class="searchBody_year" style="font-size: 15px !important;">
          생성 일자
          </div>
          <div style="margin-left: 10px">
          <el-date-picker
            v-model="confirmStartDateOption"
            type="date"
            placeholder="Pick a day"
            value-format="yyyy-MM-dd"
            class="date-input"
          >
          </el-date-picker>
          ~
          <el-date-picker
            v-model="confirmEndDateOption"
            type="date"
            placeholder="Pick a day"
            value-format="yyyy-MM-dd"
            class="date-input"
          >
          </el-date-picker>
          </div>

      </div>




      <div class="searchBody">
        <!-- 조회 조건 영역 -->
        <div class="searchBody_year" style="font-size: 15px !important;">
          국가명
        </div>
        <div  style="margin-left: 18px">
          <el-input
              placeholder=""
              v-model="countryInput"
                            class="wide-input"
              style="margin-left: 10px;"
          >
          </el-input>
        </div>
      </div>



      <div class="searchBody">
        <!-- 조회 조건 영역 -->
        <div class="searchBody_year" style="font-size: 15px !important;">
          구매자명
        </div>
        <div style="margin-left: 6px">
          <el-input
              placeholder=""
              v-model="customerInput"
                            class="wide-input"
              style="margin-left: 10px;"
          >
          </el-input>
        </div>
      </div>


        <div class="searchBody">
            <!-- 조회 조건 영역 -->
            <div class="searchBody_year" style="font-size: 15px !important;">
                여권번호
            </div>
            <div style="margin-left: 18px">
                <el-input

                        placeholder=""
                        v-model="ssnNumberInput"
                                      class="wide-input"

                >
                </el-input>
            </div>
        </div>

        <div class="searchBody">
            <!-- 조회 조건 영역 -->
            <div class="searchBody_year" style="font-size: 15px !important;">
                 사업자번호
            </div>
            <div  style="margin-left: 8px">
                <el-input

                        placeholder=""
                        v-model="crNumberInput"
                                      class="wide-input"

                >
                </el-input>
            </div>
        </div>





        <div class="searchBody">
        <!-- 조회 조건 영역 -->
        <div class="searchBody_year" style="font-size: 15px !important;">
          QR CODE
        </div>
        <div >
          <el-input
              placeholder=""
              v-model="barcodeInput"
                            class="wide-input"
              style="margin-left: 10px;"
          >
          </el-input>
        </div>
      </div>



<!--      <div class="searchBody">-->
<!--        &lt;!&ndash; 조회 조건 영역 &ndash;&gt;-->
<!--        <div class="searchBody_production" style="margin-right: 0px;width: 80px !important;">-->
<!--          QR 리딩 건수-->
<!--        </div>-->

<!--        <div>-->
<!--        <el-radio v-model="countFlag"  label="All" style="margin-right: 5px !important; padding-left: 2px !important;">전체</el-radio>-->
<!--        <el-radio v-model="countFlag"   label="Complete" style="margin-right: 5px !important; padding-left: 2px !important;">리딩완료</el-radio>-->
<!--          <el-radio v-model="countFlag"   label="Incomplete" style="margin-right: 5px !important; padding-left: 2px !important;">리딩 미완료</el-radio>-->
<!--          <el-radio v-model="countFlag"   label="Over" style="margin-right: 5px !important; padding-left: 2px !important;">리딩 오버</el-radio>-->
<!--        </div>-->

<!--      </div>-->



      <div class="searchBody"            >

        <div class="searchBody_brand">
          <el-button
            :loading="loading"
            type="primary"
            @click="search"
          >Search</el-button>
          </div>
      </div>


    </div> <!-- div class="grid-content bg-purple-light"> -->
  </el-col>

</el-row>

    <el-row>
        <el-col :span="20">
            <div class="grid-content bg-purple-light" >

 <el-table
    v-loading="loading"
    ref="multipleTable"
    :data="tableData"

    border
    @selection-change="handleSelectionChange"
     :row-class-name="tableRowClassName"
    size="small"
    :row-style="{ height: 0 + 'px' }"
    :cell-style="{ padding: 0 + 'px' }"
    :header-cell-style="{
                          background: '#2F384E',
                          color: '#fff',
                          height: '10px',
                          padding: '0px',
                        }"
 >
    <el-table-column
      type="selection"
      width="35"
      >
    </el-table-column>


    <el-table-column
        property="seq"
      label="일련번호"
      width="80">
    </el-table-column>


   <el-table-column
       property="insert_date"
       label="작업일자"
       width="130">


   </el-table-column>

   <el-table-column
       property="country"
       label="국가"
       width="130">


   </el-table-column>


   <el-table-column
       property="customer_name"
       label="구매자명"
       width="280">



   </el-table-column>


     <el-table-column
             property="ssn_number"
             label="여권번호"
             width="220">

         <!--     <template slot-scope="scope">-->
         <!--       <el-button type="text" size="small" @click="handleClick1(scope.row.big_qr_code ) " >-->
         <!--         {{scope.row.big_qr_code}}</el-button>-->
         <!--     </template>-->

     </el-table-column>

     <el-table-column
             property="cr_number"
             label="사업자번호"
             width="220">

         <!--     <template slot-scope="scope">-->
         <!--       <el-button type="text" size="small" @click="handleClick1(scope.row.big_qr_code ) " >-->
         <!--         {{scope.row.big_qr_code}}</el-button>-->
         <!--     </template>-->

     </el-table-column>



     <el-table-column
       property="count"
       label="건수"
       width="150">

     <template slot-scope="scope">
       <el-button type="text" size="small" @click="handleClick1(scope.row.auth_store_barcode_info_seq , scope.row.country, scope.row.customer_name,  scope.row.ssn_number, scope.row.cr_number   ) " >
         {{scope.row.count}}</el-button>
     </template>


   </el-table-column>


<!--   <el-table-column-->
<!--       property="customer_name"-->
<!--       label="구매자명"-->
<!--       width="130">-->

<!--     &lt;!&ndash;     <template slot-scope="scope">&ndash;&gt;-->
<!--     &lt;!&ndash;       <el-button type="text" size="small" @click="handleClick1(scope.row.big_qr_code ) " >&ndash;&gt;-->
<!--     &lt;!&ndash;         {{scope.row.big_qr_code}}</el-button>&ndash;&gt;-->
<!--     &lt;!&ndash;     </template>&ndash;&gt;-->

<!--   </el-table-column>-->


 </el-table>




 <el-row>
  <el-col :span="24"><div class="pagination"  >

<el-pagination
  small
  layout="prev, pager, next"
      :total="totalSize"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="pageSize"
  >
</el-pagination>



<!--    <el-tag type="warning" effect="dark"  style="margin-left: 10px; height: 30px"> COUNT : {{this.totalData.length}}</el-tag>-->



<!--      <el-button-->
<!--    :loading="loading"-->
<!--    type="primary"-->
<!--    @click="dialogVisible=true"-->
<!--  >출고 엑셀 파일 업로드</el-button>-->



    <el-button
        :loading="loading"
        type="primary"
        @click="dialogVisible2=true"
    >판매정보입력</el-button>


    <el-button
        :loading="loading"
        type="primary"
        @click="remove"
    >삭제</el-button>


<!--    <el-button-->
<!--        :loading="loading"-->
<!--        type="primary"-->
<!--        @click="excelDownFuncAll"-->
<!--        style="margin-left: 10px"-->
<!--    > 엑셀 다운로드 </el-button>-->



    <el-tag type="warning" effect="dark"  style="margin-left: 10px; height: 30px"> TOTAL COUNT : {{this.totalData.length}}</el-tag>


      <el-button
              :loading="loading"
              type="primary"
              @click="excelDownFuncAll"
              style="margin-left: 10px !important;"
      > 엑셀 다운로드 (전체)</el-button>

  </div> <!-- div class="grid-content bg-purple-light"> -->
  </el-col>

 </el-row>


      <el-dialog
        title="박스매핑"
        :visible.sync="dialogVisible2"
        width="30%"
        height="500px"
        v-loading="loading"
        :before-close="Confirm2"
        :close-on-click-modal="false"
        custom-class="rounded-dialog"
    >

          <el-row>
              <el-col >
                  <div >

                      <div class="searchBody">
                          <!-- 조회 조건 영역 -->
                          <div class="searchBody_year" style="font-size: 15px !important;">
                      국가명
                    </div>
                    <div style="margin-left: 22px;">
                                  <el-input
                                          placeholder=""
                                          v-model="country"
                                          class="wide-input"
                                  >
                                </el-input>

                    </div>
                  </div>



                  <div class="searchBody">
                    <!-- 조회 조건 영역 -->
                    <div class="searchBody_year" style="font-size: 15px !important;">
                      구매자명
                    </div>
                    <div style="margin-left: 10px;">
                       <el-input
                          placeholder=""
                          v-model="customer_name"
                                        class="wide-input"
                       >
                       </el-input>
                    </div>
                  </div>


                    <div class="searchBody">
                    <!-- 조회 조건 영역 -->
                    <div class="searchBody_year" style="font-size: 15px !important;">
                      여권번호
                    </div>
                    <div style="margin-left: 10px;">
                       <el-input

                               placeholder=""
                               v-model="ssn_number"
                                             class="wide-input"

                       >
                       </el-input>
                    </div>
                  </div>


                  <div class="searchBody">
                    <!-- 조회 조건 영역 -->
                    <div class="searchBody_year" style="font-size: 15px !important;">
                      사업자번호
                    </div>
                    <div >
                       <el-input

                               placeholder=""
                               v-model="cr_number"
                                             class="wide-input"
                       >
                       </el-input>
                    </div>
                  </div>



          <el-input
              id="textarea_class"
              class="textarea_class"
              type="textarea" v-model="barcode"></el-input>

              </div>
            </el-col>
          </el-row>


        <div class="searchBody_production">
       <el-button type="primary" @click="insert">등록 </el-button>

        </div>

    </el-dialog>



    <el-dialog
        title="박스매핑"
        :visible.sync="dialogVisible3"
        width="450px"
        height="500px"
        v-loading="loading"
        :before-close="Confirm2"
        :close-on-click-modal="false"
        custom-class="rounded-dialog"
    >

          <el-row>
              <el-col >
                  <div >

                      <div class="searchBody">
                          <!-- 조회 조건 영역 -->
                          <div class="searchBody_year" style="font-size: 15px !important;">
                      국가명
                    </div>
                    <div style="margin-left: 22px;">

                      <el-input
                          placeholder=""
                          v-model="edit_country"
                          class="wide-input"

                      >
                      </el-input>


                    </div>
                  </div>



                  <div class="searchBody">
                    <!-- 조회 조건 영역 -->
                    <div class="searchBody_year" style="font-size: 15px !important;">
                      구매자명
                    </div>
                    <div style="margin-left: 10px;">
                       <el-input
                               placeholder=""
                               v-model="edit_customer_name"
                               class="wide-input"

                       >
                       </el-input>
                    </div>
                  </div>


                    <div class="searchBody">
                    <!-- 조회 조건 영역 -->
                    <div class="searchBody_year" style="font-size: 15px !important;">
                      여권번호
                    </div>
                    <div style="margin-left: 10px;">
                       <el-input
                               placeholder=""
                               v-model="edit_ssn_number"
                                             class="wide-input"


                       >
                       </el-input>
                    </div>
                  </div>


                  <div class="searchBody">
                    <!-- 조회 조건 영역 -->
                    <div class="searchBody_year" style="font-size: 15px !important;">
                      사업자번호
                    </div>
                    <div >
                       <el-input

                               placeholder=""
                               v-model="edit_cr_number"
                                             class="wide-input"

                       >
                       </el-input>
                    </div>
                  </div>




      <el-input
          id="textarea_class"
          class="textarea_class"
          type="textarea" v-model="barcode2"></el-input>




              </div>
            </el-col>
          </el-row>


        <div class="searchBody_production">
       <el-button type="primary" @click="update">수정 </el-button>

        </div>

    </el-dialog>




  </div>
 </el-col>
 </el-row>

</div>
</template>


<script>
import Axios from 'axios';
import XLSX from "xlsx";


  export default {
    created() {
      this.$store.commit("dayBefore",0);
      this.confirmEndDateOption = this.$store.state.dateOption; // 조회조건에서 현재 날짜 
      this.$store.commit("dayBefore",7);
      this.confirmStartDateOption = this.$store.state.dateOption; // 조회조건이서 현재보다 -7 일
      if (this.$store.state.userId != 'admin') {
        // this.deptSeqOption = this.$store.state.deptSeq;
        // this.deptNameOption = this.$store.state.deptName;
      }

      // console.log()
      // 페이지로딩시 조회
      this.search();
      // this.search2();
      // this.search3();
      // this.getFilePath();
    },//created    
    data() {
      return {
        // table 관련 data 
        tableData: [],
        totalData: [],
        totalData2: [],
        tableData2:[],
        multipleSelection: [],
        multipleTable2 :[],

        saveData:[],
        saveData2:[],
        currentPage: 1,
        pageSize:10,
        totalSize:0,

        // loading 변수 true 이면 loging 화면 보여줌
        loading:false,

        statusOptions: [{

          value: 'I',
          label: '입고'
        },
          {
          value: 'O',
          label: '출고'
        }, ],
        brandOption: '',
        styleOption :'',
        deptNameOption:'',
        deptSeqOption:0,
        confirmStartDateOption:'',
        confirmEndDateOption:'',
        statusOption:'입고',
        status:'',     
        fileList: [],
        text :[],
        dialogVisible: false,
        dialogVisible2:false,
        dialogVisible3:false,
        statusLavel:'',
        filePath:'',
        epc :'',
        member_id :'',
        member_name : '',
        chkOutDate : false,
        items : [],
        excelJsonData :  [],
        barcode : '',
        barcode2 : '',
        inputQrCode : '',
        inputBigQrCode : '',
        countFlag:'All',
        waybill_number : '',
        big_qr_code : '',
        inPutFlag : 0,
        autoSave  : true, 
        inputWayBillNumber :'',
        countryInput :'',
        customerInput :'',
        bigoInput :'',
        barcodeInput :'',
        customer_name :'',
        country :'',
        bigo : '',
        countrys : [],
        customers : [],
        tmpCustomer : [],
        editCountry : '',
        editCustomer : '',
        editInsertDate : '',
        ssnNumberInput : '',
        crNumberInput : '',
          ssn_number  : '',
          cr_number   : '',
          auth_store_barcode_info_seq : '',
          edit_country : '',
          edit_customer_name : '',
          edit_ssn_number : '',
          edit_cr_number : '',

      } // return 
    },// data

    methods: {

      inputChange(event){
        // console.log(event)
        //
        // console.log(event.length)
        //

        if (this.autoSave) {

          if (event.substr(-1) == '\n') {
            this.inPutFlag = 1 + this.inPutFlag;
          }

          if (this.inPutFlag == 2) {
            this.qrSave();
            this.barcode = "";
            this.inPutFlag = 0;
          }
        }
      },

      // handleClick1(big_qr_code ){
      //   this.search2(big_qr_code);
      // },

      handleClick1(auth_store_barcode_info_seq, country, customer_name, ssn_number, cr_number){
        this.search4(auth_store_barcode_info_seq, country, customer_name, ssn_number, cr_number);
      },


      async search2() {

        this.loading = true;

        // default data
        let url = this.$url + '/authStoreInfo/getCountry';
        var reqJson = new Object();

        reqJson.user_seq = this.$store.state.rfid_get_order_seq;

        await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
          var resDataJson = res.data.authStoreInfoDTO;

          //console.log("=====search2================") ;
          //console.log(resDataJson) ;

          this.countrys=[];

          if (res.data.resultCode) {

            for (var resData in resDataJson) {

              this.countrys.push({
                seq: resData * 1 + 1
                , country: resDataJson[resData]['country']
              });
            }
          }

        }) // await Axios.post
            .catch(error => {
              console.log(error.response)
              this.$message.error(this.$store.state.serverErrorMessage);
              this.loading = false;
            }); // await Axios.post
      },//

      handleCheckedChange() {

        this.tmpCustomer=[];

          for (var resData in this.customers) {

            if (this.country == this.customers[resData]['country'] ) {

              this.tmpCustomer.push({
                seq: resData * 1 + 1
                , country: this.customers[resData]['country']
                , customer_name: this.customers[resData]['store']

              });
            }
          }
      },

      async search3() {

        this.loading = true;

        // default data
        let url = this.$url + '/authStoreInfo/getStore';
        var reqJson = new Object();

        reqJson.user_seq = this.$store.state.rfid_get_order_seq;

        await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
          var resDataJson = res.data.authStoreInfoDTO;

          //console.log("=====222222222222222222================") ;
          //console.log(resDataJson) ;

          this.customers=[];

          if (res.data.resultCode) {

            for (var resData in resDataJson) {

              this.customers.push({
                seq: resData * 1 + 1
                , country: resDataJson[resData]['country']
                , customer_name: resDataJson[resData]['customer_name']

              });
            }
          }

        }) // await Axios.post
            .catch(error => {
              console.log(error.response)
              this.$message.error(this.$store.state.serverErrorMessage);
              this.loading = false;
            }); // await Axios.post
      },//




      async search4(auth_store_barcode_info_seq, country, customer_name, ssn_number, cr_number) {

        this.loading = true;

        // default data
        let url = this.$url + '/NextPlayInfo/getQrList';
        var reqJson = new Object();
        reqJson.auth_store_barcode_info_seq = auth_store_barcode_info_seq;
        this.auth_store_barcode_info_seq =  auth_store_barcode_info_seq;

        console.log ("*****************************");
          console.log (reqJson.auth_store_barcode_info_seq );
          console.log (this.auth_store_barcode_info_seq );
          console.log (auth_store_barcode_info_seq );
          console.log ("*****************************");

        // this.barcode2 = "";
        // this.editCountry = country;
        // this.editInsertDate  = insert_date;
        // this.orgInsertDate=insert_date;
        // this.editCustomer = customer_name;

          this.barcode2 = "";
          this.edit_country = country;
          this.edit_customer_name = customer_name;
          this.edit_ssn_number = ssn_number;
          this.edit_cr_number = cr_number;

        await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
          var resDataJson = res.data.nextPlayInfoDTO;

          //console.log("=====search2================") ;
          //console.log(resDataJson) ;
          if (res.data.resultCode) {

            for (var resData in resDataJson) {

              this.barcode2 =  this.barcode2 + resDataJson[resData]['qr_code'] + '\n'
            }
          }

          this.dialogVisible3 = true;

        }) // await Axios.post
            .catch(error => {
              console.log(error.response)
              this.$message.error(this.$store.state.serverErrorMessage);
              this.loading = false;
            }); // await Axios.post
      },//


      async search(){
        this.loading = true;

        // default data
        let url = this.$url + '/nextPlayBarcodeInfo/nextPlaylist';
        var reqJson = new Object();


        reqJson.in_start_date = this.confirmStartDateOption;
        reqJson.in_end_date = this.confirmEndDateOption;
        reqJson.country = this.countryInput;
        reqJson.customer_name = this.customerInput;

        reqJson.ssn_number = this.ssnNumberInput;
        reqJson.cr_number = this.crNumberInput;

        reqJson.barcode = this.barcodeInput;

        reqJson.user_seq = this.$store.state.rfid_get_order_seq;



        await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
          var resDataJson = res.data.authStoreBarcodeInfoDTO;
          this.totalData=[];

          if (res.data.resultCode){

            for (var resData in resDataJson) {

                this.totalData.push({
                  seq: resData  * 1 + 1
                  , insert_date : resDataJson[resData]['insert_date']
                  , country : resDataJson[resData]['country']
                  , customer_name : resDataJson[resData]['customer_name']
                  , ssn_number : resDataJson[resData]['ssn_number']
                  , cr_number : resDataJson[resData]['cr_number']
                  , count : resDataJson[resData]['count']
                  , user_seq : resDataJson[resData]['user_seq']
                  , auth_store_barcode_info_seq :  resDataJson[resData]['auth_store_barcode_info_seq']
                });

            }
            // 전체 데이터 사이즈
            this.totalSize = this.totalData.length;
            // 보여주는 부분만 slice
            this.tableData = this.totalData.slice(0, this.pageSize);
            this.currentPage = 1;
            this.loading = false;
            this.status = reqJson.status;
            this.$message.success(this.$store.state.searchSuccess);
          }else{
            this.$message.error(this.$store.state.dataNotFound);
            this.currentPage = 1;
            this.loading = false;
          }
        }) // await Axios.post
        .catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }); // await Axios.post
      },//search

      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      }, //toggleSelection

      // check box click event 
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      tableRowClassName({row, rowIndex}) {
        if (rowIndex === 1) {
        //  return 'warning-row';
        } else if (rowIndex === 3) {
        //  return 'success-row';
        }
         console.log(row);
        return '';
      },    
      handleSizeChange(val) {
        console.log(`${val} items per page`);
      },

      // pagging event 
      handleCurrentChange(val) {
        this.tableData = this.totalData.slice( (this.pageSize * val - this.pageSize )   , this.pageSize * val);
      },
      //
      // async excelDownFunc(){
      //
      //   if(this.multipleSelection==null || this.multipleSelection.length == 0 ){
      //     this.$message.error(this.$store.state.noDataSelect);
      //     return ;
      //   }
      //
      //   this.loading = true;
      //
      //   // default data
      //   let url = this.$url + '/rfidInfo/reDowload';
      //   // var reqJson = new Object();
      //
      //   await Axios.post(url, this.multipleSelection , this.$store.state.config ).then(res => {
      //     let saveCount = res.data;
      //
      //
      //     if (saveCount){
      //       this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
      //       this.loading = false;
      //
      //     }else{
      //       this.$message.error(this.$store.state.serverErrorMessage);
      //       this.currentPage = 1;
      //       this.loading = false;
      //     }
      //   }) // await Axios.post
      //       .catch(error => {
      //         console.log(error.response)
      //         this.$message.error(this.$store.state.serverErrorMessage);
      //         this.currentPage = 1;
      //         this.loading = false;
      //       }); // await Axios.post
      //
      //
      // }, //excelDownFunc



      async pathUpload(){


        this.loading = true;

        // default data
        let url = this.$url + '/saveInfo/pathUpdate';
        var reqJson = new Object();


        reqJson.file_full_path = this.filePath;

        await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
          let saveCount = res.data;

          if (saveCount){
            this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
            this.loading = false;

          }else{
            this.$message.error(this.$store.state.serverErrorMessage);
            this.currentPage = 1;
            this.loading = false;
          }
        }) // await Axios.post
            .catch(error => {
              console.log(error.response)
              this.$message.error(this.$store.state.serverErrorMessage);
              this.currentPage = 1;
              this.loading = false;
            }); // await Axios.post


      }, //excelDownFunc

      getCheckSum(hex)
      {
        var chk = hex.length
        var value = 0;
        for(var i=0; i <hex.length; i += 2) {
          value +=  parseInt(hex.substring(i, i+2),16) * chk
          chk ++;
        }
        var res = value * 1224 % 100;
        if (res <= 9)
          return '0' + res;
        else
          return res;
      },

      convertToHex(str) {
          var hex = '';
          for(var i=0;i<str.length;i++) {
            hex += str.charCodeAt(i).toString(16);
          }
        return hex;
      },

      convertToString(hex) {

        //console.log("convertToString");
        //console.log(hex);

        var str = '';
        for(var i=0;i<hex.length; i += 2) {
          str += String.fromCharCode(parseInt(hex.substring(i, i+2),16))
        }
        return str;
      },

      filesChange(event) {
        // get File object from input tag
        this.loading = true;

        const file = event.target.files[0];
        let reader = new FileReader();
        let tmpResult = {};
        reader.onload = (e) => {

          console.log(e);

          let data = reader.result;
          let workbook = XLSX.read(data, {type: 'binary'});
          workbook.SheetNames.forEach(sheetName => {
            workbook.Sheets[sheetName].A1.w = "region";
            workbook.Sheets[sheetName].B1.w = "waybill_number";
            workbook.Sheets[sheetName].C1.w = "sender";
            workbook.Sheets[sheetName].D1.w = "sender_hp";

            workbook.Sheets[sheetName].E1.w = "sender_manager";
            workbook.Sheets[sheetName].F1.w = "sender_manager_hp";
            workbook.Sheets[sheetName].G1.w = "sender_zip_code";
            workbook.Sheets[sheetName].H1.w = "sender_address";

            workbook.Sheets[sheetName].I1.w = "receiver";
            workbook.Sheets[sheetName].J1.w = "receiver_hp";
            workbook.Sheets[sheetName].K1.w = "receiver_manager";
            workbook.Sheets[sheetName].L1.w = "receiver_manager_hp";

            workbook.Sheets[sheetName].M1.w = "receiver_zip_code";
            workbook.Sheets[sheetName].N1.w = "receiver_address";
            workbook.Sheets[sheetName].O1.w = "fare_type";

            workbook.Sheets[sheetName].P1.w = "payment_type";
            workbook.Sheets[sheetName].Q1.w = "release_number";


            workbook.Sheets[sheetName].R1.w = "remark";

            workbook.Sheets[sheetName].S1.w = "memo1";
            workbook.Sheets[sheetName].T1.w = "memo2";

            workbook.Sheets[sheetName].U1.w = "memo3";
            workbook.Sheets[sheetName].V1.w = "memo4";

            workbook.Sheets[sheetName].W1.w = "lbl_hub_code";
            workbook.Sheets[sheetName].X1.w = "product_name1";
            workbook.Sheets[sheetName].Y1.w = "product_count1";


            workbook.Sheets[sheetName].Z1.w = "product_name2";
            workbook.Sheets[sheetName].AA1.w = "product_count2";
            workbook.Sheets[sheetName].AB1.w = "product_name3";
            workbook.Sheets[sheetName].AC1.w = "product_count3";


            workbook.Sheets[sheetName].AD1.w = "product_name4";
            workbook.Sheets[sheetName].AE1.w = "product_count4";
            workbook.Sheets[sheetName].AF1.w = "product_name5";
            workbook.Sheets[sheetName].AG1.w = "product_count5";

            workbook.Sheets[sheetName].AH1.w = "product_name6";
            workbook.Sheets[sheetName].AI1.w = "product_count6";
            workbook.Sheets[sheetName].AJ1.w = "product_name7";
            workbook.Sheets[sheetName].AK1.w = "product_count7";



            workbook.Sheets[sheetName].AL1.w = "product_name8";
            workbook.Sheets[sheetName].AM1.w = "product_count8";

            workbook.Sheets[sheetName].AN1.w = "product_name9";


            workbook.Sheets[sheetName].AO1.w = "product_count9";
            workbook.Sheets[sheetName].AP1.w = "product_name10";
            workbook.Sheets[sheetName].AQ1.w = "product_count10";
            workbook.Sheets[sheetName].AR1.w = "product_name11";


            workbook.Sheets[sheetName].AS1.w = "product_count11";
            workbook.Sheets[sheetName].AT1.w = "product_name12";


            workbook.Sheets[sheetName].AU1.w = "product_count12";


            workbook.Sheets[sheetName].AV1.w = "product_name13";


            workbook.Sheets[sheetName].AW1.w = "product_count13";
            workbook.Sheets[sheetName].AX1.w = "product_name14";
            workbook.Sheets[sheetName].AY1.w = "product_count14";
            workbook.Sheets[sheetName].AZ1.w = "product_name15";




            workbook.Sheets[sheetName].BA1.w = "product_count15";
            workbook.Sheets[sheetName].BB1.w = "product_name16";
            workbook.Sheets[sheetName].BC1.w = "product_count16";
            workbook.Sheets[sheetName].BD1.w = "product_name17";
            workbook.Sheets[sheetName].BE1.w = "product_count17";
            workbook.Sheets[sheetName].BF1.w = "product_name18";


            workbook.Sheets[sheetName].BG1.w = "product_count18";
            workbook.Sheets[sheetName].BH1.w = "product_name19";
            workbook.Sheets[sheetName].BI1.w = "product_count19";
            workbook.Sheets[sheetName].BJ1.w = "product_name20";


            workbook.Sheets[sheetName].BK1.w = "product_count20";
            workbook.Sheets[sheetName].BL1.w = "product_name21";
            workbook.Sheets[sheetName].BM1.w = "product_count21";
            workbook.Sheets[sheetName].BN1.w = "product_name22";


            workbook.Sheets[sheetName].BO1.w = "product_count22";
            workbook.Sheets[sheetName].BP1.w = "product_name23";
            workbook.Sheets[sheetName].BQ1.w = "product_count23";


            workbook.Sheets[sheetName].BR1.w = "product_name24";
            workbook.Sheets[sheetName].BS1.w = "product_count24";
            workbook.Sheets[sheetName].BT1.w = "product_name25";
            workbook.Sheets[sheetName].BU1.w = "product_count25";


            workbook.Sheets[sheetName].BV1.w = "product_name26";
            workbook.Sheets[sheetName].BW1.w = "product_count26";


            //console.log(workbook.Sheets[sheetName].A1);
            const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
            tmpResult = roa;
          });

          //console.log("=====================================");
          //console.log(tmpResult);
          this.excelJsonData=tmpResult;


          let url = "";
          url = this.$url + '/claWayBillInfo/insert';

          Axios.post(url, this.excelJsonData , this.$store.state.config  ).then(res => {

            //console.log(res);
            let saveCount = res.data;
            this.loading = false;
            this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
            this.search();
            // this.$refs.myFiles.files[0].name = null;
          }).catch(error => {
            console.log(error.response)
            this.$message.error(this.$store.state.serverErrorMessage);
            this.currentPage = 1;
            this.loading = false;
          }); // await Axios.post



        };
        reader.readAsBinaryString(file);
              
      },//filesChange

      Confirm(){
        // this.e.target.files[0].name = "";

        this.$refs.form.reset() ;
        this.dialogVisible = false;
        this.dialogVisible2 = false;
        this.search();

      },

      Confirm2(){
        // this.e.target.files[0].name = "";

        //console.log ("Confirm2") ;
        this.country = "";
        this.customer_name = "";
        this.cr_number = "";
        this.ssn_number = "";
        this.bigo="";
        this.barcode2 = "";
        this.barcode = "";

        this.dialogVisible2 = false;
        this.dialogVisible3 = false;

        // this.auth_store_barcode_info_seq = "";

        this.search();

      },

      Confirm3(){
        // this.e.target.files[0].name = "";

        this.barcode2 = "";
        this.dialogVisible3 = false;

      },


      async update(){

        if ( this.barcode2.length < 1)
        {
          this.$message.error(" 바코드를 입력해주세요");
          return ;
        }


        var array = this.barcode2.split('\n');

          console.log("===================================================");
          console.log(this.barcode2 );
          console.log( array.length );
          console.log( this.auth_store_barcode_info_seq);
          console.log("===================================================");

        var resDataJson = [];

        for ( var idx = 0 ; idx < array.length  ; idx++ ) {
          resDataJson.push({
            barcode: array[idx],
              auth_store_barcode_info_seq : this.auth_store_barcode_info_seq,
              country : this.edit_country,
              customer_name : this.edit_customer_name,
              ssn_number : this.edit_ssn_number,
              cr_number : this.edit_cr_number,
            user_seq : this.$store.state.rfid_get_order_seq,
          });
        }


        let url = this.$url + '/nextPlayBarcodeInfo/nextPlayUpdate';

        Axios.post(url, resDataJson , this.$store.state.config  ).then(res => {

          //console.log(res );
          let saveCount = res.data;
          this.loading = false;
          this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);



         // this.search();
        }).catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.loading = false;
        }); // await Axios.post

      },


      async insert(){


        if ( this.country.length <1)
        {

          this.country = "국가명 없음"
          // this.$message.error(" 국가명을 입력해주세요");
          // return ;
        }

        if ( this.customer_name.length <1)
        {

            this.customer_name = "구매자명 없음"
          // this.$message.error(" 구매자명을 입력해주세요");
          // return ;
        }



        var array = this.barcode.split('\n');

        var resDataJson = [];

        for ( var idx = 0 ; idx < array.length  ; idx++ ) {
            if (array[idx].length > 10) {
                resDataJson.push({
                    barcode: array[idx],
                    country: this.country,
                    customer_name: this.customer_name,
                    ssn_number: this.ssn_number,
                    cr_number: this.cr_number,
                    user_seq: this.$store.state.rfid_get_order_seq,
                });
            }
        }

        let url = this.$url + '/nextPlayBarcodeInfo/nextPlayinsert';

        Axios.post(url, resDataJson , this.$store.state.config  ).then(res => {

          //console.log(res );
          let saveCount = res.data;
          this.loading = false;
          this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);

          this.barcode = "";

          // this.search();
        }).catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.loading = false;
        }); // await Axios.post

      },


      submitUpload() {
        this.$refs.upload.submit();
      },



      async excelDownFuncAll(){


        this.loading = true;

        // default data
        let url = this.$url + '/nextPlayBarcodeInfo/getListForExcel';
        var reqJson = new Object();
        var excepData=[];


        reqJson.in_start_date = this.confirmStartDateOption;
        reqJson.in_end_date = this.confirmEndDateOption;
        reqJson.country = this.countryInput;
        reqJson.customer_name = this.customerInput;
        reqJson.barcode = this.barcodeInput;
        reqJson.user_seq = this.$store.state.rfid_get_order_seq;


        await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
          var resDataJson = res.data.authStoreBarcodeInfoDTO;

          if (res.data.resultCode){

            for (var resData in resDataJson) {


              excepData.push({
                일련번호 : resData  * 1 + 1
                ,작업일자 : resDataJson[resData]['insert_date']
                ,국가 :  resDataJson[resData]['country']
                ,구매자명 : resDataJson[resData]['customer_name']
                  ,여권번호 : resDataJson[resData]['ssn_number']
                  ,사업자번호 : resDataJson[resData]['cr_number']
                ,QRCODE :  resDataJson[resData]['barcode']
              });


            }

          }else{
            this.$message.error(this.$store.state.dataNotFound);
            this.loading = false;
          }
        }) // await Axios.post
            .catch(error => {
              console.log(error.response)
              this.$message.error(this.$store.state.serverErrorMessage);
              this.currentPage = 1;
              this.loading = false;
            }); // await Axios.post




        // var excepData = [];
        //
        // for (var i in this.tmpData) {
        //   excepData.push({
        //     일련번호 : this.totalData[i]['seq']
        //     ,작업일자 : this.totalData[i]['insert_date']
        //     ,대박스번호 : this.totalData[i]['big_qr_code']
        //     ,소박스매핑건수 : this.totalData[i]['total_count']
        //   });
        // }
        //
        // this.loading = true;
        var dataWS = XLSX.utils.json_to_sheet(excepData);
        var wb = XLSX.utils.book_new();
        // workbook에 워크시트 추가
        // 시트명은 'nameData'
        XLSX.utils.book_append_sheet(wb, dataWS, '넥스트플레이어판매데이터');
        // 엑셀 파일을 내보낸다.
        this.$store.commit("dayBefore",0); // 오늘날짜
        XLSX.writeFile(wb, "넥스트플레이어판매데이터"+'.xlsx');
        this.loading = false;


      },//excelDownFunc



      async remove(){
        if (this.multipleSelection.length <= 0)
        {
          this.$message.error("데이터를 선택하세요 ");
          return ;
        }
        this.loading = true;
        let url = "";
        url = this.$url + '/nextPlayBarcodeInfo/nextPlayRemove';
        Axios.post(url, this.multipleSelection , this.$store.state.config  ).then(res => {

          //console.log(res );
          let saveCount = res.data;
          this.loading = false;
          this.$message.success(saveCount +'건 삭제 되었습니다.');
          this.search(false);

        }).catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }); // await Axios.post
      }, // remove



    }, //methods
  }
</script>


<style>

.el-dialog__body {
  padding: 10px 20px !important;
}

.textarea_class {
  height: 300px !important;
}

.el-textarea__inner {

  height: 100% !important;

}



.searchBody_production {
  width: 100px !important;
  margin-left: 20px !important;
}

</style>

